import { render, staticRenderFns } from "./ProzessSidebarModal.vue?vue&type=template&id=1f4d2ead"
import script from "./ProzessSidebarModal.vue?vue&type=script&lang=js"
export * from "./ProzessSidebarModal.vue?vue&type=script&lang=js"
import style0 from "./ProzessSidebarModal.vue?vue&type=style&index=0&id=1f4d2ead&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports